import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgSocialGoogle = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M12 10.182v3.873h5.382a4.611 4.611 0 0 1-2.01 3.009l3.246 2.518c1.891-1.746 2.982-4.31 2.982-7.355 0-.709-.064-1.39-.182-2.045H12ZM6.396 13.903l-.732.56-2.591 2.019C4.718 19.745 8.09 22 12 22c2.7 0 4.963-.89 6.618-2.418l-3.246-2.518c-.89.6-2.027.963-3.372.963-2.6 0-4.81-1.754-5.6-4.118l-.004-.006Z"
    />
    <path
      fill="#88827E"
      d="M3.073 7.518A9.877 9.877 0 0 0 2 12c0 1.618.39 3.136 1.073 4.482C3.073 16.49 6.4 13.9 6.4 13.9c-.2-.6-.318-1.236-.318-1.9 0-.664.118-1.3.318-1.9L3.073 7.518Z"
    />
    <path
      fill="#88827E"
      d="M12 5.982c1.473 0 2.782.509 3.827 1.49l2.864-2.863C16.955 2.991 14.7 2 12 2 8.09 2 4.718 4.245 3.073 7.518L6.4 10.1c.79-2.364 3-4.118 5.6-4.118Z"
    />
  </svg>
);
export default SvgSocialGoogle;
